import { cn } from "@amazing-care/ui/lib/utils";
import { useResolvedTheme } from "@/stores/theme.store";

interface AmazingCareLogoProps {
  className?: string;
}

export function AmazingCareLogo({ className }: AmazingCareLogoProps) {
  const theme = useResolvedTheme();

  return (
    <img
      src={theme === "dark" ? "/amazing-care-logo-dark.svg" : "/amazing-care-logo-light.svg"}
      alt="Amazing Care"
      width={405}
      height={110}
      className={cn("h-auto w-auto", className)}
    />
  );
}
